import { assert } from '~/lib/customAssert'
import { Alert } from '@mui/material'
import { useEffect, useState } from 'react'

export const isLowerThanIOS15 = (ua: string) => {
  const isIOS = /iPhone|iPad|iPod/i.test(ua)
  if (!isIOS) return false

  const version = ua.match(/OS (\d+)_(\d+)_?(\d+)?/)
  if (!version) return false
  assert(version[1])
  // [0]にはマッチした文字列全体、[1]にメジャーバージョンが入る
  const major = parseInt(version[1], 10)
  return major < 15
}

export const OldIOSAlert = () => {
  const [showAlert, setShowAlert] = useState(false)
  useEffect(() => {
    const ua = navigator.userAgent
    setShowAlert(isLowerThanIOS15(ua))
  }, [navigator.userAgent])
  return showAlert ? (
    <Alert
      severity="warning"
      closeText="閉じる"
      onClose={() => {
        setShowAlert(false)
      }}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
      }}
    >
      お使いの端末（iOS14以下）では正常に動作しない可能性があります。OSアップデートを行なってください。
    </Alert>
  ) : null
}
